__turbopack_context__.v({
  "content": "Details-module-scss-module__brK1bq__content",
  "details": "Details-module-scss-module__brK1bq__details",
  "slideDown": "Details-module-scss-module__brK1bq__slideDown",
  "slideUp": "Details-module-scss-module__brK1bq__slideUp",
  "trigger": "Details-module-scss-module__brK1bq__trigger",
});
